import React, { Component, Fragment } from 'react'
import Rest from "../../services/Rest";
import { Link } from "react-router-dom";

const stateInicial = {
    registroNuevoUsuario: {
        usuario: "",
        email: "",
        pass: "",
        rep_pass: ""
    },
    error: false,
    message: "",
    success: false

}


export default class Register extends Component {


    constructor(props) {
        super(props);
        this.Rest = new Rest();
    }


    state = { ...stateInicial };

    handleSubmit = (e) => {

        e.preventDefault();

        const { usuario, pass, rep_pass, email } = this.state.registroNuevoUsuario
        if (usuario === "" || pass === "" || email === "") {
            this.setState({
                error: true,
                message: "Todos los campos son obligatorios"
            })
            return;
        }

        if (pass !== rep_pass) {
            this.setState({
                error: true,
                message: "Las contraseñas no coinciden"
            })
            return;
        }

        this.registrarUsuario();
    }

    handleChange = (e) => {
        this.setState({
            registroNuevoUsuario: {
                //copiar state
                ...this.state.registroNuevoUsuario,
                [e.target.name]: e.target.value
            }
        })
    }

    registrarUsuario() {
        this.refs.btn.setAttribute("disabled", "disabled");
        this.refs.btn.innerHTML = "Registrando...";
        this.Rest.registro(this.state.registroNuevoUsuario, "usuarios/nuevo", "usuario")
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        error: false,
                        success: true,
                        message: "Te has registrado correctamente, hemos enviado los datos de acceso al correo electrónico proporcionado."
                    })
                    this.refs.btn.innerHTML = "Registrado";
                }
                else {
                    if (response.status === 404) {
                        localStorage.removeItem('ls');
                        window.location = window.location.origin;
                    }
                    else {
                        this.setState({
                            success: false,
                            error: true,
                            message: response.message
                        })
                        this.refs.btn.removeAttribute("disabled", "disabled");
                        this.refs.btn.innerHTML = "Registrar";
                    }
                }
            })
            .catch(err => {
                this.setState({
                    success: false,
                    error: true,
                    message: err
                })
            })
    }


    render() {
        //esxtraer error
        const { error, message, success } = this.state;
        return (
            <Fragment>
                <section>
                    <div className="form-login-container">
                        {error ? <div className="alert alert-danger">{message}</div> : null}
                        {success ? <div className="alert alert-success">{message} <a className="btn btn-success btn-block" href={window.location.origin}>Iniciar sesión</a></div> : null}
                        <form onSubmit={this.handleSubmit} autoComplete="off">
                            <div className="form-group">
                                <label>Usuario</label>
                                <input type="text" name="usuario" id="usuario" className="form-control" onChange={this.handleChange} value={this.state.registroNuevoUsuario.usuario}></input>
                            </div>
                            <div className="form-group">
                                <label>Correo electrónico</label>
                                <input type="text" name="email" id="email" className="form-control" onChange={this.handleChange} value={this.state.registroNuevoUsuario.email}></input>
                            </div>
                            <div className="form-group">
                                <label>Contraseña</label>
                                <input type="password" name="pass" id="pass" className="form-control" onChange={this.handleChange} value={this.state.registroNuevoUsuario.pass}></input>
                            </div>
                            <div className="form-group">
                                <label>Repetir Contraseña</label>
                                <input type="password" name="rep_pass" id="rep_pass" className="form-control" onChange={this.handleChange} value={this.state.registroNuevoUsuario.rep_pass}></input>
                            </div>
                            <button className="btn btn-primary" type="submit" ref="btn">Registrarse</button>
                            <Link to="/" className="btn btn-default ml-3" ref="btnCancel">Cancelar</Link>
                        </form>
                    </div>
                </section>
            </Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/main/Register.js